var _rect, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProfilepic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.2133 14.4927C16.08 14.4793 15.92 14.4793 15.7733 14.4927C12.6 14.386 10.08 11.786 10.08 8.58602C10.08 5.31935 12.72 2.66602 16 2.66602C19.2667 2.66602 21.92 5.31935 21.92 8.58602C21.9067 11.786 19.3867 14.386 16.2133 14.4927Z",
    fill: "#828282",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.54666 19.414C6.32 21.574 6.32 25.094 9.54666 27.2407C13.2133 29.694 19.2267 29.694 22.8933 27.2407C26.12 25.0807 26.12 21.5607 22.8933 19.414C19.24 16.974 13.2267 16.974 9.54666 19.414Z",
    fill: "#828282",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfilepic);
export default __webpack_public_path__ + "static/media/profilepic.2ec07a760426fd8a1ccaf42002dc570f.svg";
export { ForwardRef as ReactComponent };